import { render, staticRenderFns } from "./AddNewsItemPage.vue?vue&type=template&id=25330d3a&scoped=true&"
import script from "./AddNewsItemPage.vue?vue&type=script&lang=js&"
export * from "./AddNewsItemPage.vue?vue&type=script&lang=js&"
import style0 from "./AddNewsItemPage.vue?vue&type=style&index=0&id=25330d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25330d3a",
  null
  
)

export default component.exports